import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import Button from "../Button";
import useAfterUpdateEffect from "../../utils/useAfterUpdateEffect";
import CodeCameraScanner from "./CodeCameraScanner";

const CodeCameraScannerModal = props => {
  const [isOpen, setIsOpen] = useState(false)

  useAfterUpdateEffect(() => {
    if(props.onModalOpen){
      props.onModalOpen(isOpen)
    }
  }, [isOpen])

  return <React.Fragment>
    <Button color={'light'} onClick={() => setIsOpen(true)}><i className="fas fa-barcode" /></Button>
    {isOpen && <Modal isOpen>
      <ModalHeader toggle={() => setIsOpen(!isOpen)}>Skanuj kod kreskowy</ModalHeader>
      <ModalBody>
        <CodeCameraScanner
          qrCodeSuccessCallback={text => {
            props.onScan(text)
            setIsOpen(false)
          }}
        />
      </ModalBody>
    </Modal>}
  </React.Fragment>;
};

CodeCameraScannerModal.propTypes = {
  onModalOpen: PropTypes.func,
  onScan: PropTypes.func.isRequired,
};

export default CodeCameraScannerModal;